"use client";

import { useState } from "react";
import { useRouter } from "next/navigation";

export function CheckoutButton({
  plan,
  href,
  label,
  className,
}: {
  plan: string;
  href: string;
  label: string;
  className: string;
}) {
  const [loading, setLoading] = useState(false);
  const router = useRouter();

  const paymentsEnabled = process.env.NEXT_PUBLIC_PAYMENTS_ENABLED === "true";

  async function handleClick() {
    // Free plan — just redirect to sign up
    if (plan === "free") {
      router.push(href);
      return;
    }

    if (!paymentsEnabled) return;

    setLoading(true);
    try {
      const res = await fetch("/api/checkout", {
        method: "POST",
        headers: { "Content-Type": "application/json" },
        body: JSON.stringify({ plan }),
      });

      if (res.status === 401) {
        // Not logged in — send to auth first, return to pricing
        router.push(`/auth?mode=signup&redirect=/pricing`);
        return;
      }

      const data = await res.json();
      if (data.url) {
        window.location.href = data.url; // Stripe checkout
      }
    } catch {
      // silently fail — user can retry
    } finally {
      setLoading(false);
    }
  }

  if (!paymentsEnabled && plan !== "free") {
    return (
      <button disabled className={className} style={{ opacity: 0.5, cursor: "not-allowed" }}>
        Coming Soon
      </button>
    );
  }

  return (
    <button onClick={handleClick} disabled={loading} className={className}>
      {loading ? "Loading…" : label}
    </button>
  );
}
